module.exports = __webpack_public_path__ + "static/balcony-nav-square-e668013c951c19f111f7f367daa577c4.jpeg";